(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ri-product-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.supportReady) return;
    root.dataset.supportReady = 'true';
    const products = Array.from(root.querySelectorAll('[data-support-product]'));
    const panels = Array.from(root.querySelectorAll('[data-support-panel]'));
    function selectProduct(id) {
      products.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.supportProduct === id)));
      panels.forEach(panel => { panel.hidden = panel.dataset.supportPanel !== id; });
    }
    products.forEach(button => button.addEventListener('click', () => selectProduct(button.dataset.supportProduct)));
    panels.forEach(panel => {
      const tabs = Array.from(panel.querySelectorAll('[role="tab"]'));
      function selectTopic(tab) {
        tabs.forEach(button => {
          const selected = button === tab;
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
          panel.querySelector('#' + CSS.escape(button.getAttribute('aria-controls'))).hidden = !selected;
        });
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTopic(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); selectTopic(tabs[next]); tabs[next].focus();
        });
      });
    });
    const section = root.closest('.shopify-section');
    if (section) section.addEventListener('shopify:block:select', event => {
      const panel = event.target.closest('[data-support-panel]');
      if (panel) selectProduct(panel.dataset.supportPanel);
    });
  }
  function scan(scope) { scope.querySelectorAll('[data-product-support]').forEach(initialize); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
